import { Paper, Table, TableBody, TableContainer } from "@hiver/hiver-ui-kit";
import React from "react";
import ConversationTableHeader from "./ConversationTableHeader";
import ConversationRow from "./CoversationRow";
import PlaceholderComponent from "./PlaceholderComponent";

export const ConversationTable = ({
  conversations,
  isLoading,
  testResults,
  onTestClicked,
  disableAllTestButton,
  gainsightProps = {},
}) => {
  const showPlaceholder = isLoading || conversations.length <= 0;
  const placeholderText = isLoading
    ? "Please wait, loading conversations"
    : "No results found";
  return (
    <TableContainer
      component={Paper}
      sx={{
        mr: "auto",
        mt: 2,
        minHeight: 0,
        overflowX: "hidden",
      }}
    >
      {showPlaceholder ? (
        <PlaceholderComponent
          isLoading={isLoading}
          placeholderText={placeholderText}
        />
      ) : (
        <Table stickyHeader sx={{ tableLayout: "fixed", width: "100%" }}>
          <ConversationTableHeader />
          <TableBody>
            {conversations.map((conversation) => (
              <ConversationRow
                key={conversation.gmailunit_id}
                conversation={conversation}
                testResults={testResults}
                onTestClicked={onTestClicked}
                disableAllTestButton={disableAllTestButton}
                gainsightProps={gainsightProps}
              />
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};
